import React from 'react';
import { motion } from 'framer-motion';
export const VideoDemoSection = () => {
  return <section id="video-demo" className="py-16 md:py-24 bg-brand-darkest relative overflow-hidden" data-id="element-657">
      <div className="container mx-auto px-4" data-id="element-658">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-659">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4" data-id="element-660">
            Real <span className="text-brand-glow" data-id="element-661">Action</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-662">
            Watch how the QTap tag works in real life — one tap to unlock your
            profile
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-4xl mx-auto" data-id="element-663">
          <div className="relative aspect-video rounded-2xl overflow-hidden bg-brand-dark border border-white/10 shadow-[0_0_30px_rgba(0,102,255,0.15)]" data-id="element-664">
            <video controls muted loop playsInline preload="metadata" className="w-full h-full object-cover" data-id="element-665">
              <source src="https://cdn.magicpatterns.com/uploads/boqgyMYvxudrFV4EnD65ve/WhatsApp%20Video%202026-03-24%20at%204.21.47%20PM.mp4" type="video/mp4" data-id="element-666" />
              Your browser does not support the video tag.
            </video>
          </div>
        </motion.div>
      </div>
    </section>;
};